import React, { Component } from "react";
import { Spin, message, Checkbox, Radio, Space } from "antd";
import Bridge from "../../utils/Bridge";

export default class MedicalConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adhd: false,
      anxiety: false,
      bipolar_disorder: false,
      brain_aneurysm: false,
      cancer: false,
      concussion: false,
      cognitive_impairment: false,
      dementia: false,
      depression: false,
      diabetes: false,
      epilepsy: false,
      muscle_disease: false,
      schizophrenia: false,
      loading: false,

      is_check_all: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            this.setState({
              adhd: response.data[0].adhd == "Yes" ? true : false,
              anxiety: response.data[0].anxiety == "Yes" ? true : false,
              bipolar_disorder:
                response.data[0].bipolar_disorder == "Yes" ? true : false,
              brain_aneurysm:
                response.data[0].brain_aneurysm == "Yes" ? true : false,
              cancer: response.data[0].cancer == "Yes" ? true : false,
              concussion: response.data[0].concussion == "Yes" ? true : false,
              cognitive_impairment:
                response.data[0].cognitive_impairment == "Yes" ? true : false,
              dementia: response.data[0].dementia == "Yes" ? true : false,
              depression: response.data[0].depression == "Yes" ? true : false,
              diabetes: response.data[0].diabetes == "Yes" ? true : false,
              epilepsy: response.data[0].epilepsy == "Yes" ? true : false,
              muscle_disease:
                response.data[0].muscle_disease == "Yes" ? true : false,
              schizophrenia:
                response.data[0].schizophrenia == "Yes" ? true : false,
            });
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  save = () => {
    let params = {
      bipolar_disorder: this.state.bipolar_disorder == true ? "Yes" : "No",
      brain_aneurysm: this.state.brain_aneurysm == true ? "Yes" : "No",
      cancer: this.state.cancer == true ? "Yes" : "No",
      depression: this.state.depression == true ? "Yes" : "No",
      diabetes: this.state.diabetes == true ? "Yes" : "No",
      epilepsy: this.state.epilepsy == true ? "Yes" : "No",
      muscle_disease: this.state.muscle_disease == true ? "Yes" : "No",
      schizophrenia: this.state.schizophrenia == true ? "Yes" : "No",
      eals_id: localStorage.getItem("ap_eals_id"),
      step: "6",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(7);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeDiagnosedHairLoss = (event) => {
    this.setState({ diagnosed_hair_loss: event.target.value });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>MEDICAL CONDITIONS</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(5)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
